// ผังฟอร์มรับสมัคร
//
// ระบบเดิมมีคอมโพเนนต์ฟอร์ม 7 ตัว (อนุบาล/ประถม/ม.ต้น/ม.ปลาย x ใหม่/เก่า + แก้ไข)
// ตัวละประมาณ 1,000 บรรทัด ที่ copy กันมาแล้วต่างกันจริงราว 250 บรรทัด
// การเพิ่มช่องกรอกหนึ่งช่องจึงต้องแก้ 7 ที่ และมักลืมบางที่
//
// ที่นี่ "ฟอร์ม" คือข้อมูล ไม่ใช่โค้ด: ApplicantForm เรนเดอร์ตามผังนี้ตัวเดียว
// แต่ละระดับต่างกันแค่ว่ามองเห็น section/field ไหนบ้าง (ดู sectionsFor)
//
// path ต้องตรงกับ FIELDS ใน server/models/admissionModel.js เป๊ะๆ
// เพราะ payload ที่ส่งไปเป็น nested object ตาม path เดียวกันนี้

export const STUDIES = [
  { value: 'anubal',  label: 'อนุบาล' },
  { value: 'prathom', label: 'ประถมศึกษา' },
  { value: 'junior',  label: 'มัธยมศึกษาตอนต้น' },
  { value: 'high',    label: 'มัธยมศึกษาตอนปลาย' },
]

export const CLASS_BY_STUDY = {
  anubal:  [['a1', 'อนุบาล 1'], ['a2', 'อนุบาล 2'], ['a3', 'อนุบาล 3']],
  prathom: [['p1', 'ป.1'], ['p2', 'ป.2'], ['p3', 'ป.3'], ['p4', 'ป.4'], ['p5', 'ป.5'], ['p6', 'ป.6']],
  junior:  [['h1', 'ม.1'], ['h2', 'ม.2'], ['h3', 'ม.3']],
  high:    [['h4', 'ม.4'], ['h5', 'ม.5'], ['h6', 'ม.6']],
}

export const PROGRAMS = [
  ['simp', 'SIMP'], ['smp', 'SMP'], ['aip', 'AIP'], ['amp', 'AMP'],
  ['asp', 'ASP'], ['ap', 'AP'], ['stp', 'STP'], ['aep', 'AEP'],
]

const YES_NO_LIFE = [['1', 'มีชีวิตอยู่'], ['0', 'เสียชีวิต']]

const PARENT_STATUS = [
  ['togather', 'อยู่ด้วยกัน'],
  ['separated', 'แยกกันอยู่'],
  ['divorce', 'หย่าร้าง'],
]

const GUARDIAN_KIND = [['dad', 'บิดา'], ['mom', 'มารดา'], ['other', 'อื่นๆ']]

const GENDERS = [['m', 'ชาย'], ['f', 'หญิง']]

const BLOODS = [['A', 'A'], ['B', 'B'], ['AB', 'AB'], ['O', 'O']]

// ชุดช่องกรอกของ "คน" หนึ่งคน (บิดา/มารดา) — เดิมเขียนซ้ำสองรอบในทุกฟอร์ม
//
// ลำดับช่องเรียงตามที่เครื่องอ่านบัตรประชาชนคายข้อมูลออกมา (เลขบัตร -> ชื่อ -> วันเกิด
// -> ที่อยู่ -> ตำบล -> อำเภอ -> จังหวัด) จะได้กรอกไล่ลงมาโดยไม่ต้องกระโดดข้ามช่อง
const personFields = (group, label) => [
  { path: `${group}.idcard`,      label: 'เลขบัตรประชาชน', col: 3, maxLength: 13, digits: true },
  { path: `${group}.name`,        label: `ชื่อ-นามสกุล${label}`, col: 6, namePrefix: true },
  { path: `${group}.birthdate`,   label: 'วันเกิด', col: 3, type: 'thaiDate' },
  { path: `${group}.address`,     label: 'บ้านเลขที่ / หมู่ / ถนน', col: 6 },
  { path: `${group}.subDistrict`, label: 'ตำบล', col: 3 },
  { path: `${group}.district`,    label: 'อำเภอ', col: 3 },
  { path: `${group}.province`,    label: 'จังหวัด', col: 3 },
  { path: `${group}.zipcode`,     label: 'รหัสไปรษณีย์', col: 3, maxLength: 5, digits: true },
  { path: `${group}.life`,        label: 'สถานะ', col: 3, type: 'select', options: YES_NO_LIFE },
  { path: `${group}.phone`,       label: 'เบอร์โทร', col: 3, digits: true, maxLength: 15 },
  { path: `${group}.nationality`, label: 'สัญชาติ', col: 3, default: 'ไทย' },
  { path: `${group}.race`,        label: 'เชื้อชาติ', col: 3, default: 'ไทย' },
  { path: `${group}.job`,         label: 'อาชีพ', col: 3 },
  { path: `${group}.workPlace`,   label: 'สถานที่ทำงาน', col: 3 },
  { path: `${group}.income`,      label: 'รายได้ต่อปี (บาท)', col: 3, type: 'number' },
]

// ชั้นที่จบสายสามัญ — ระบบเดิมเป็น select แต่มีแค่ ป.6 กับ ม.1-ม.6 เพราะฟอร์มประถม
// ไม่มีช่องนี้เลย ที่นี่ฟอร์มเดียวใช้ทุกสาย จึงเอาชั้นทั้งหมดจากผังเดียวกับชั้นที่สมัคร
// (ข้อมูลเดิมทุกแถวเป็น p6/h1-h6 ซึ่งอยู่ในรายการนี้อยู่แล้ว)
const PREV_ACADEMIC_CLASSES = Object.values(CLASS_BY_STUDY).flat()

// ชั้นที่จบสายศาสนา — ยกรายการมาจากระบบเดิมทั้งชุด ตาดีกาเก็บเป็น '0'
const PREV_ISLAMIC_CLASSES = [
  ['0', 'ตาดีกา'],
  ...Array.from({ length: 10 }, (_, i) => [String(i + 1), `ชั้น ${i + 1}`]),
]

// ที่อยู่โรงเรียนเดิม — ใช้ทั้งสายสามัญและสายศาสนา
const schoolFields = (group, classOptions) => [
  { path: `${group}.class`,       label: 'ชั้นที่จบ', col: 3, type: 'select', options: classOptions },
  { path: `${group}.school`,      label: 'ชื่อโรงเรียน', col: 5 },
  { path: `${group}.subDistrict`, label: 'ตำบล', col: 4 },
  { path: `${group}.district`,    label: 'อำเภอ', col: 4 },
  { path: `${group}.province`,    label: 'จังหวัด', col: 4 },
]

export const SECTIONS = [
  {
    key: 'admission',
    title: 'ข้อมูลการสมัคร',
    icon: 'ri-file-add-line',
    fields: [
      { path: 'admission.academicStudy',   label: 'สายที่สมัคร', col: 4, type: 'select',
        options: STUDIES.map((s) => [s.value, s.label]), required: true },
      { path: 'admission.academicClass',   label: 'ชั้นที่สมัคร', col: 4, type: 'classSelect', required: true },
      { path: 'admission.academicProgram', label: 'แผนการเรียน', col: 4, type: 'select',
        options: PROGRAMS, levels: ['junior', 'high'] },
    ],
  },
  {
    key: 'student',
    title: 'ข้อมูลผู้สมัคร',
    icon: 'ri-user-line',
    fields: [
      // เรียงตามที่เครื่องอ่านบัตรประชาชนคายข้อมูลออกมา — เลขบัตรมาก่อนชื่อ
      // (และเป็นช่องที่ตรวจซ้ำให้ด้วย ได้รู้ตั้งแต่ยังไม่กรอกอะไรว่าเคยสมัครไปแล้วหรือยัง)
      { path: 'student.idcard',      label: 'เลขบัตรประชาชน', col: 3, maxLength: 13, digits: true, checkIdCard: true },
      // ระบบเดิมเดาเพศจากคำนำหน้าชื่อ และตกเป็น "หญิง" เมื่อไม่รู้จักคำนำหน้า
      // ที่นี่ให้เลือกเอง แต่เติมให้อัตโนมัติจากคำนำหน้าเพื่อไม่ให้ช้าลง (ดู guessGender)
      // namePrefix: เว้นวรรคหลังคำนำหน้าให้เอง (ดู splitNamePrefix)
      { path: 'student.name',        label: 'ชื่อ-นามสกุล (พร้อมคำนำหน้า)', col: 6, required: true, namePrefix: true },
      { path: 'student.birthdate',   label: 'วันเกิด', col: 3, type: 'thaiDate' },
      { path: 'student.gender',      label: 'เพศ', col: 3, type: 'radio', options: GENDERS, required: true },
      { path: 'student.arabicName',  label: 'ชื่อภาษาอาหรับ', col: 6 },
      { path: 'student.blood',       label: 'กรุ๊ปเลือด', col: 3, type: 'select', options: BLOODS },
      // ค่าตั้งต้น: ข้อมูลจริง 6,37x จาก 6,374 แถวเป็นค่าเหล่านี้ ใส่ให้เลยจะได้ไม่ต้องพิมพ์ซ้ำ
      // ทุกใบ แก้ทับได้ตามปกติ และถ้าดึงระเบียนนักเรียนเก่ามา ค่าจริงจะทับค่าตั้งต้นให้
      { path: 'student.nationality', label: 'สัญชาติ', col: 3, default: 'ไทย' },
      { path: 'student.race',        label: 'เชื้อชาติ', col: 3, default: 'ไทย' },
      { path: 'student.religion',    label: 'ศาสนา', col: 3, default: 'อิสลาม' },
      { path: 'student.childOrder',  label: 'เป็นบุตรคนที่', col: 3, type: 'number' },
      { path: 'student.syndrome',    label: 'โรคประจำตัว', col: 4 },
      { path: 'student.drug',        label: 'ยาที่แพ้', col: 4 },
      { path: 'student.food',        label: 'อาหารที่แพ้', col: 4 },
    ],
  },
  {
    key: 'address',
    title: 'ที่อยู่ปัจจุบัน',
    icon: 'ri-home-4-line',
    fields: [
      { path: 'address.detail',      label: 'บ้านเลขที่ / หมู่ / ถนน', col: 6 },
      { path: 'address.subDistrict', label: 'ตำบล', col: 3 },
      { path: 'address.district',    label: 'อำเภอ', col: 3 },
      { path: 'address.province',    label: 'จังหวัด', col: 3 },
      { path: 'address.zipcode',     label: 'รหัสไปรษณีย์', col: 3, maxLength: 5, digits: true },
      // เลขรหัสประจำบ้านไม่ได้อยู่บนหน้าบัตร ต้องเปิดจากทะเบียนบ้าน ไปท้ายสุด
      { path: 'address.homeId',      label: 'เลขรหัสประจำบ้าน', col: 6 },
    ],
  },
  {
    key: 'dorm',
    title: 'หอพัก',
    icon: 'ri-community-line',
    // อยู่ถัดจากข้อมูลผู้สมัครโดยตั้งใจ ไม่ใช่รวมอยู่ในข้อมูลการสมัคร
    // เพราะเขตหอพักแยกชาย-หญิงและใช้เลขซ้ำกัน (เขต 3 มีทั้งของชายและหญิง)
    // ต้องรู้เพศก่อนจึงจะเลือกเขตได้ถูก — ช่องเพศอยู่ในหัวข้อก่อนหน้านี้
    levels: ['junior', 'high'],
    fields: [
      { path: 'admission.dormZone',   label: 'เขตหอพัก', col: 4, type: 'dormZone' },
      { path: 'admission.dormNumber', label: 'หมายเลขหอพัก', col: 4, type: 'dormBuilding' },
    ],
  },
  {
    key: 'prevAcademic',
    title: 'สถานศึกษาเดิม (สามัญ)',
    icon: 'ri-school-line',
    fields: schoolFields('prevAcademic', PREV_ACADEMIC_CLASSES),
  },
  {
    key: 'prevIslamic',
    title: 'สถานศึกษาเดิม (ศาสนา)',
    icon: 'ri-book-open-line',
    // โรงเรียนศาสนาเดิมถามเฉพาะสายมัธยม เหมือนระบบเดิม
    levels: ['junior', 'high'],
    fields: schoolFields('prevIslamic', PREV_ISLAMIC_CLASSES),
  },
  {
    key: 'father',
    title: 'ข้อมูลบิดา',
    icon: 'ri-parent-line',
    fields: personFields('father', 'บิดา'),
  },
  {
    key: 'mother',
    title: 'ข้อมูลมารดา',
    icon: 'ri-parent-line',
    fields: personFields('mother', 'มารดา'),
  },
  {
    key: 'guardian',
    title: 'ข้อมูลผู้ปกครอง',
    icon: 'ri-user-heart-line',
    fields: [
      { path: 'guardian.kind',        label: 'ผู้ปกครองคือ', col: 3, type: 'select', options: GUARDIAN_KIND },
      { path: 'guardian.name',        label: 'ชื่อ-นามสกุลผู้ปกครอง', col: 6, namePrefix: true },
      { path: 'guardian.relation',    label: 'ความสัมพันธ์กับผู้สมัคร', col: 3 },
      { path: 'guardian.idcard',      label: 'เลขบัตรประชาชน', col: 3, maxLength: 13, digits: true },
      { path: 'guardian.birthdate',   label: 'วันเกิด', col: 3, type: 'thaiDate' },
      { path: 'guardian.phone',       label: 'เบอร์โทร', col: 3, digits: true, maxLength: 15 },
      { path: 'guardian.job',         label: 'อาชีพ', col: 3 },
      { path: 'guardian.address',     label: 'ที่อยู่', col: 6 },
      { path: 'guardian.subDistrict', label: 'ตำบล', col: 3 },
      { path: 'guardian.district',    label: 'อำเภอ', col: 3 },
      { path: 'guardian.province',    label: 'จังหวัด', col: 3 },
      { path: 'guardian.zipcode',     label: 'รหัสไปรษณีย์', col: 3, maxLength: 5, digits: true },
      { path: 'guardian.workPlace',   label: 'สถานที่ทำงาน', col: 6 },
      { path: 'guardian.income',      label: 'รายได้ต่อปี (บาท)', col: 3, type: 'number' },
    ],
  },
  {
    key: 'family',
    title: 'ข้อมูลครอบครัว',
    icon: 'ri-group-line',
    fields: [
      { path: 'family.parentStatus',    label: 'สถานะบิดามารดา', col: 4, type: 'select', options: PARENT_STATUS },
      { path: 'family.sibling',         label: 'จำนวนพี่น้องทั้งหมด (คน)', col: 4, type: 'number' },
      { path: 'family.studyingSibling', label: 'พี่น้องที่กำลังศึกษาอยู่ (คน)', col: 4, type: 'number' },
    ],
  },
  {
    key: 'emergency',
    title: 'ผู้ติดต่อกรณีฉุกเฉิน',
    icon: 'ri-phone-line',
    fields: [
      { path: 'emergency.firstName', label: 'ชื่อ', col: 4 },
      { path: 'emergency.lastName',  label: 'นามสกุล', col: 4 },
      { path: 'emergency.phone',     label: 'เบอร์โทร', col: 4, digits: true, maxLength: 15 },
    ],
  },
]

// section/field ที่ระบุ levels ไว้ จะโผล่เฉพาะสายที่อยู่ในรายการ
const visibleAt = (item, study) => !item.levels || item.levels.includes(study)

export const sectionsFor = (study) =>
  SECTIONS
    .filter((s) => visibleAt(s, study))
    .map((s) => ({ ...s, fields: s.fields.filter((f) => visibleAt(f, study)) }))
    .filter((s) => s.fields.length > 0)

// ทุก path ที่ฟอร์มของสายนี้แสดง — ใช้ตัดสินว่าจะส่งอะไรไป server
// (ไม่ส่ง = อย่ายุ่งกับคอลัมน์นั้น ต่างจากส่งค่าว่าง = ตั้งใจลบ)
export const pathsFor = (study) =>
  sectionsFor(study).flatMap((s) => s.fields.map((f) => f.path))

/* ── แปลงระหว่างแถวใน DB กับค่าในฟอร์ม ─────────────────────────────────── */

// คอลัมน์ใน tb_student ของแต่ละ path — ต้องตรงกับ FIELDS ฝั่ง server
export const COLUMN_OF = {
  'student.idcard': 'st_idcard', 'student.name': 'st_name', 'student.arabicName': 'st_arabicname',
  'student.gender': 'st_gen', 'student.birthdate': 'st_birthdate', 'student.nationality': 'st_nationality',
  'student.race': 'st_race', 'student.religion': 'st_religion', 'student.blood': 'st_blood',
  'student.childOrder': 'st_childnumber', 'student.syndrome': 'st_syndrome', 'student.drug': 'st_drug',
  'student.food': 'st_food',

  'address.homeId': 'st_homeID', 'address.detail': 'st_current',
  'address.subDistrict': 'st_currentSubDistrict', 'address.district': 'st_currentDistrict',
  'address.province': 'st_currentProvince', 'address.zipcode': 'st_zipcode',

  'prevAcademic.class': 'st_prevAcademicClass', 'prevAcademic.school': 'st_prevAcademicSchool',
  'prevAcademic.subDistrict': 'st_prevAcademicSubDistrict', 'prevAcademic.district': 'st_prevAcademicDistrict',
  'prevAcademic.province': 'st_prevAcademicProvince',

  'prevIslamic.class': 'st_prevIslamicClass', 'prevIslamic.school': 'st_prevIslamicSchool',
  'prevIslamic.subDistrict': 'st_prevIslamicSubDistrict', 'prevIslamic.district': 'st_prevIslamicDistrict',
  'prevIslamic.province': 'st_prevIslamicProvince',

  'admission.academicStudy': 'regis_academicStudy', 'admission.academicClass': 'regis_academicClass',
  'admission.academicProgram': 'regis_academicProgram',
  'admission.dormZone': 'dorn_zone', 'admission.dormNumber': 'dorn_number',

  'father.name': 'st_fatherName', 'father.idcard': 'st_fatherIdCard', 'father.birthdate': 'st_fatherBirthdate',
  'father.address': 'st_fatherAddress', 'father.subDistrict': 'st_fatherSubDistrict',
  'father.district': 'st_fatherDistrict', 'father.province': 'st_fatherProvince',
  'father.zipcode': 'st_fatherZipcode', 'father.nationality': 'st_fatherNationality',
  'father.race': 'st_fatherRace', 'father.life': 'st_fatherLife', 'father.job': 'st_fatherJob',
  'father.workPlace': 'st_fatherWorkPlace', 'father.income': 'st_fatherAnnualIncome',
  'father.phone': 'st_fatherPhone',

  'mother.name': 'st_motherName', 'mother.idcard': 'st_motherIdCard', 'mother.birthdate': 'st_motherBirthdate',
  'mother.address': 'st_motherAddress', 'mother.subDistrict': 'st_motherSubDistrict',
  'mother.district': 'st_motherDistrict', 'mother.province': 'st_motherProvince',
  'mother.zipcode': 'st_motherZipcode', 'mother.nationality': 'st_motherNationality',
  'mother.race': 'st_motherRace', 'mother.life': 'st_motherLife', 'mother.job': 'st_motherJob',
  'mother.workPlace': 'st_motherWorkPlace', 'mother.income': 'st_motherAnnualIncome',
  'mother.phone': 'st_motherPhone',

  'guardian.kind': 'st_parent', 'guardian.idcard': 'st_parentIdCard', 'guardian.name': 'st_parentname',
  'guardian.birthdate': 'st_parentBirthdate', 'guardian.relation': 'st_parentRelation',
  'guardian.address': 'st_parentAddress', 'guardian.subDistrict': 'st_parentSubDistrict',
  'guardian.district': 'st_parentDistrict', 'guardian.province': 'st_parentProvince',
  'guardian.zipcode': 'st_parentZipcode', 'guardian.job': 'st_parentjob',
  'guardian.workPlace': 'st_parentWorkPlace', 'guardian.income': 'st_parentannualincome',
  'guardian.phone': 'st_parentPhone',

  'family.parentStatus': 'st_parentStatus', 'family.sibling': 'st_sibling',
  'family.studyingSibling': 'st_studyingSibling',

  'emergency.firstName': 'st_emergencyFirstName', 'emergency.lastName': 'st_emergencyLastName',
  'emergency.phone': 'st_emergencyPhone',
}

const FIELD_BY_PATH = new Map(SECTIONS.flatMap((s) => s.fields.map((f) => [f.path, f])))

// ค่าตั้งต้นของฟอร์มรับสมัครใหม่ (หน้าแก้ไขไม่ใช้ เพราะโหลดค่าจริงจากระเบียนมาแล้ว)
export const DEFAULTS = Object.fromEntries(
  SECTIONS.flatMap((s) => s.fields).filter((f) => f.default).map((f) => [f.path, f.default])
)

// ค่าจาก DB เป็น ISO (หรือ Date ที่ axios แปลงเป็นสตริง) — ฟอร์มใช้ input[type=date]
// ซึ่งต้องการ yyyy-mm-dd จึงตัดเอาแค่ 10 ตัวแรก
// mysql2 คืนคอลัมน์ DATE เป็น Date object ที่เที่ยงคืนตามเวลาเครื่อง (UTC+7)
// พอผ่าน JSON มาถึงหน้าเว็บจะกลายเป็น "2013-07-08T17:00:00.000Z" คือ 17:00 ของ "เมื่อวาน"
// การตัดสิบตัวแรกของสตริงจึงได้วันก่อนหน้าหนึ่งวัน ต้องอ่านเป็นเวลาท้องถิ่นเสมอ
// (เอกสารที่พิมพ์ออกมาอ่านแบบนี้อยู่แล้ว ค่าที่เห็นในฟอร์มจึงจะตรงกับที่พิมพ์)
const localParts = (value) => {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 1900) return null
  return { day: d.getDate(), month: d.getMonth() + 1, year: d.getFullYear() }
}

const pad2 = (n) => String(n).padStart(2, '0')

// ค.ศ. จาก DB -> วว/ดด/ปปปป พ.ศ. สำหรับกรอกในฟอร์ม
export const toThaiDate = (value) => {
  const p = localParts(value)
  return p ? `${pad2(p.day)}/${pad2(p.month)}/${p.year + 543}` : ''
}

// รูปแบบที่ server (asDate) รับได้ — ส่ง พ.ศ. ไปตรงๆ ให้ server แปลงเป็น ค.ศ.
// ตรวจฝั่งนี้ด้วยเพราะค่าที่ asDate แปลงไม่ได้จะกลายเป็น null = ล้างวันเกิดเดิมทิ้ง
export const isThaiDate = (text) => {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(text || '').trim())
  if (!m) return false
  const [, day, month, year] = m.map(Number)
  if (month < 1 || month > 12 || day < 1 || day > 31) return false
  if (year < 2400 || year > 2600) return false
  const ce = new Date(year - 543, month - 1, day)
  return ce.getDate() === day && ce.getMonth() === month - 1
}

// เติม / ให้ระหว่างพิมพ์ จะได้กดแต่ตัวเลขรวดเดียว
// ถ้าคนพิมพ์ / เองหลังเลขหลักเดียว ให้เติม 0 นำหน้าให้ (9/7/2556 -> 09/07/2556)
export const thaiDateInput = (raw) => {
  const parts = String(raw).replace(/[^\d/]/g, '').split('/')
  const digits = parts
    .map((part, i) => (i < parts.length - 1 && part.length === 1 ? `0${part}` : part))
    .join('')
    .slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

// แถวจาก tb_student -> ค่าในฟอร์ม (nested ตาม path)
export const rowToForm = (row) => {
  const form = {}
  for (const [path, column] of Object.entries(COLUMN_OF)) {
    const [group, key] = path.split('.')
    if (!form[group]) form[group] = {}
    const raw = row[column]
    const field = FIELD_BY_PATH.get(path)
    form[group][key] = field?.type === 'thaiDate' ? toThaiDate(raw) : (raw ?? '')
  }
  return form
}

// ข้อมูลของนักเรียนเก่าที่ดึงมาเติมฟอร์มให้ ไม่ต้องคีย์ซ้ำทั้งใบ
//
// สามกลุ่มนี้ห้ามลอกจากระเบียนเดิม:
//   admission    ใบสมัครใบนี้ต้องเลือกสาย/ชั้น/แผนใหม่ ไม่ใช่ของตอนเข้า ม.1
//   prevAcademic / prevIslamic  ของเดิมคือโรงเรียนก่อนเข้ามาที่นี่ ไม่ใช่ชั้นที่เพิ่งจบ
// ลอกมาแล้วจะกลายเป็นข้อมูลผิดที่ถูกพิมพ์ลงใบสมัครโดยไม่มีใครทันสังเกต
const NOT_FROM_OLD_RECORD = ['admission', 'prevAcademic', 'prevIslamic']

export const prefillFromStudent = (row) => {
  const form = rowToForm(row)
  for (const group of NOT_FROM_OLD_RECORD) delete form[group]
  return form
}

// ค่าในฟอร์ม -> payload ส่ง server เฉพาะ path ที่ฟอร์มของสายนี้แสดงจริง
export const formToPayload = (form, study) => {
  const payload = {}
  for (const path of pathsFor(study)) {
    const [group, key] = path.split('.')
    if (!payload[group]) payload[group] = {}
    payload[group][key] = form[group]?.[key] ?? ''
  }
  return payload
}

/* ── คำนำหน้าชื่อ ──────────────────────────────────────────────────────── */

// คำนำหน้าที่รู้จัก -> เพศที่คำนั้นสื่อ
const NAME_PREFIXES = [
  ['นาย', 'm'], ['เด็กชาย', 'm'], ['ด.ช.', 'm'], ['ดช.', 'm'],
  ['นาง', 'f'], ['นางสาว', 'f'], ['น.ส.', 'f'], ['นส.', 'f'],
  ['เด็กหญิง', 'f'], ['ด.ญ.', 'f'], ['ดญ.', 'f'],
]

// จับคู่จากยาวไปสั้น ไม่งั้น "นางสาว" จะถูก "นาง" คว้าไปก่อน
const BY_LENGTH = [...NAME_PREFIXES].sort((a, b) => b[0].length - a[0].length)

// ยังพิมพ์คำนำหน้าไม่จบ? "นาง" อาจกำลังจะเป็น "นางสาว" / "ด.ช" ยังขาดจุดท้าย
const stillTyping = (text) =>
  NAME_PREFIXES.some(([p]) => p.length > text.length && p.startsWith(text))

// สระและวรรณยุกต์ไทยที่เป็นตัวแรกของคำไม่ได้ (ะ ั า ำ ิ ี ึ ื ุ ู ๅ ็ ่ ้ ๊ ๋ ์ ฯลฯ)
// เขียนเป็นรหัสยูนิโค้ดเพราะเครื่องหมายพวกนี้ต้องเกาะพยัญชนะ ใส่ตรงๆ ในโค้ดแล้วอ่านไม่ออก
const CANT_START_WORD = /[\u0E30-\u0E3A\u0E45-\u0E4E]/

// เว้นวรรคหลังคำนำหน้าชื่อให้เอง: "นายสมชาย ใจดี" -> "นาย สมชาย ใจดี"
//
// ทำระหว่างพิมพ์ทีละตัวได้เพราะรอจนแน่ใจว่าคำนำหน้าจบแล้ว — พิมพ์ "นาง" ยังไม่เว้น
// เพราะอาจกำลังจะเป็น "นางสาว" ต่อเมื่อตัวถัดไปไม่ใช่ "ส" ถึงรู้ว่าจบ แล้วค่อยเว้นย้อนหลัง
// และไม่เติมช่องว่างท้ายสุดตอนที่ยังไม่มีชื่อตามหลัง ไม่งั้นจะลบคำนำหน้าด้วย backspace ไม่ได้
export const splitNamePrefix = (value) => {
  const text = String(value ?? '')
  const parts = /^(\s*)(\S+)([\s\S]*)$/.exec(text)
  if (!parts) return text

  const [, lead, head, tail] = parts
  if (stillTyping(head)) return text

  const hit = BY_LENGTH.find(([p]) => head.startsWith(p))
  if (!hit) return text

  const rest = head.slice(hit[0].length)
  // สระ/วรรณยุกต์พวกนี้ต้องเกาะพยัญชนะ ขึ้นต้นชื่อไม่ได้ — เจอแปลว่าตัดผิดที่
  // เช่น "นายิกา" ไม่ใช่ นาย + ิกา และ "นางาม" ไม่ใช่ นาง + าม
  if (CANT_START_WORD.test(rest.charAt(0))) return text

  return rest ? `${lead}${hit[0]} ${rest}${tail}` : text
}

// ผู้ใช้เพิ่งลบช่องว่างที่เราเติมให้ทิ้งไหม — แปลว่าเราตัดคำนำหน้าผิด
//
// บางชื่อแยกไม่ออกจริงๆ: "นางสาวณีย์" เป็น นางสาว+ณีย์ หรือ นาง+สาวณีย์ ก็ได้
// เราเดายาวไว้ก่อน แต่ต้องยอมให้แก้ ไม่งั้นเติมช่องว่างคืนทุกครั้งที่ลบ = แก้ไม่ได้เลย
export const undidNamePrefix = (before, after) => {
  const prev = String(before ?? '')
  const next = String(after ?? '')
  if (next.length !== prev.length - 1) return false
  return NAME_PREFIXES.some(([p]) =>
    prev.startsWith(`${p} `) && next === p + prev.slice(p.length + 1))
}

// เดาเพศจากคำนำหน้าชื่อเพื่อ "เติมให้" ไม่ใช่ "ตัดสินแทน" —
// ต่างจากระบบเดิมที่เดาแล้วบันทึกเลย และเดาผิดเป็นหญิงเสมอเมื่อไม่มีคำนำหน้า
export const guessGender = (fullName) => {
  const head = String(fullName || '').trim().split(/\s+/)[0] || ''
  return BY_LENGTH.find(([p]) => head.startsWith(p))?.[1] || ''
}

export const CLASS_LABEL = Object.fromEntries(
  Object.values(CLASS_BY_STUDY).flat()
)

export const STUDY_LABEL = Object.fromEntries(STUDIES.map((s) => [s.value, s.label]))
